<template>
  <div class="payment-card">
    <BaseInput :label="label">
      <div v-if="isLoading" class="skele-loader">
        <SkeleLoader :lines="3" imgSize="50px" />
        <SkeleLoader :lines="3" imgSize="50px" />
        <SkeleLoader :lines="3" imgSize="50px" />
      </div>
      <div v-else v-for="paymentItem in paymentMethods" :key="paymentItem">
        <PaymentCard
          name="payment"
          :payment="paymentItem"
          :class="{
            '--is-selected':
              selectedPayment === paymentItem?.code.toLowerCase(),
          }"
          :hideDescription="hideDescription"
          @selectPayment="$emit('selectPayment', paymentItem)"
        />
      </div>
    </BaseInput>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import PaymentCard from "@/components/ui/cards/PaymentCard.vue";
import BaseInput from "@/components/ui/inputs/BaseInput.vue";
import {
  assignCohort,
  checkExistingCohort,
} from "@/composables/splittest/useSplitTests";

const props = defineProps({
  items: { type: Array, default: () => [] },
  label: {
    type: String,
    default: "Payment method",
  },
  hideDescription: {
    type: Boolean,
    default: false,
  },
  selectedPayment: {
    type: String,
    default: "",
  },
});

const splitTestEnabled = ref(false);
const cohort = ref(null);

const handleSplitTest = (payArr) => {
  let result = payArr;
  const testName = `ACH Test - Zengo - 15% split`;
  cohort.value = checkExistingCohort(testName);

  if (cohort.value === null) {
    cohort.value = assignCohort(testName, 50, 3);
  }

  if (cohort.value === "a") {
    result = payArr.filter((el) => {
      return el.code !== "FTACH";
    });
  }

  return result;
};

const paymentMethods = computed(() => {
  return splitTestEnabled.value ? handleSplitTest(props.items) : props.items;
});

onMounted(() => {
  if (window.location.href.includes("zengo.banxa.com")) {
    splitTestEnabled.value = true;
  }
});

defineEmits(["selectPayment"]);
</script>

<style lang="scss">
$breakpoint: 968px;
.skele-loader {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  grid-gap: 1rem;

  @media screen and (min-width: $breakpoint) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.payment-card {
  .base-input__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    grid-gap: 1rem;

    @media screen and (min-width: $breakpoint) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
}
</style>
